function initNotifyMeModal(notifyForm) {
  const modal = notifyForm.closest('x-modal') || document.getElementById(notifyForm.dataset.modalId);
  const productFormId = notifyForm.dataset.productFormId;
  const productForm = productFormId ? document.getElementById(productFormId) : null;
  if (!modal || !notifyForm) return;

  const klaviyoCompanyId = notifyForm.dataset.klaviyoCompanyId || '';
  const modalContent = notifyForm.closest('.notify-me-modal__content');
  const copySource = modalContent?.querySelector('[data-notify-me-copy]');

  const intro = modalContent?.querySelector('[data-notify-me-intro]');
  const introTitle = modalContent?.querySelector('[data-notify-me-title]');
  const introDescription = modalContent?.querySelector('[data-notify-me-description]');
  const successTitleCopy = copySource?.querySelector('[data-notify-me-success-title]');
  const successDescriptionCopy = copySource?.querySelector('[data-notify-me-success-description]');
  const backToProductCopy = copySource?.querySelector('[data-notify-me-back-to-product]');
  const errorCopy = copySource?.querySelector('[data-notify-me-error]');

  const fields = notifyForm.querySelector('[data-notify-me-fields]');
  const submitButton = notifyForm.querySelector('.notify-me-modal__submit');
  const emailInput = notifyForm.querySelector('input[name="email"]');

  const defaultTitle = introTitle?.textContent ?? '';
  const defaultDescription = introDescription?.textContent ?? '';
  const defaultSubmitLabel = submitButton?.querySelector('.button__content, button-content')?.textContent ?? '';

  const setButtonLabel = (label) => {
    const buttonContent = submitButton?.querySelector('.button__content, button-content');
    if (buttonContent) {
      buttonContent.textContent = label;
      buttonContent.removeAttribute('rotated-text');
      buttonContent.removeAttribute('up-text');
    }
  };

  const resetNotifyModal = () => {
    notifyForm.classList.remove('is-success');
    intro?.classList.remove('is-success');
    if (introTitle) introTitle.textContent = defaultTitle;
    if (introDescription) introDescription.textContent = defaultDescription;
    if (fields) fields.hidden = false;
    notifyForm.reset();
    if (submitButton) {
      submitButton.type = 'submit';
      submitButton.removeAttribute('aria-busy');
      setButtonLabel(defaultSubmitLabel);
    }
  };

  const showSuccessState = () => {
    notifyForm.classList.add('is-success');
    intro?.classList.add('is-success');
    if (introTitle && successTitleCopy) introTitle.textContent = successTitleCopy.textContent;
    if (introDescription && successDescriptionCopy) introDescription.textContent = successDescriptionCopy.textContent;
    if (fields) fields.hidden = true;
    if (submitButton) {
      submitButton.type = 'button';
      submitButton.removeAttribute('aria-busy');
      setButtonLabel(backToProductCopy?.textContent ?? '');
    }
  };

  const showErrorState = () => {
    if (introDescription && errorCopy) introDescription.textContent = errorCopy.textContent;
  };

  modal.querySelector('.notify-me-modal__close')?.addEventListener('click', () => {
    if (typeof modal.hide === 'function') modal.hide();
  });

  modal.addEventListener('dialog:after-hide', resetNotifyModal);

  const getVariantFromPicker = () => {
    const variantPicker =
      productForm?.closest('.shopify-section')?.querySelector(`variant-picker[form-id="${productFormId}"]`) ||
      document.querySelector(`variant-picker[form-id="${productFormId}"]`);
    return JSON.parse(variantPicker?.querySelector('script[data-variant]')?.textContent || '{}');
  };

  const isVariantEligibleForNotify = (variant) => {
    if (!variant?.id || variant.available !== false) return false;

    const continuesWhenOos = variant.inventory_policy === 'continue';
    const inventoryTracked = variant.inventory_management != null;
    const quantity = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : 0;

    if (continuesWhenOos && inventoryTracked && quantity <= 0) return false;

    return true;
  };

  const subscribeToKlaviyoBackInStock = async (email, variantId) => {
    const response = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(klaviyoCompanyId)}`,
      {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2024-07-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`
                }
              }
            }
          }
        })
      }
    );

    if (!response.ok) {
      throw new Error('Klaviyo back-in-stock subscription failed');
    }
  };

  const syncVariantId = (variant) => {
    const variantInput = notifyForm.querySelector('[data-notify-variant-id]');
    if (variantInput && variant?.id) variantInput.value = variant.id;

    if (!isVariantEligibleForNotify(variant) && typeof modal.hide === 'function') {
      modal.hide();
    }
  };

  productForm?.addEventListener('variant:change', (event) => {
    syncVariantId(event.detail?.variant);
  });

  const variantInput = productForm?.querySelector('input[name="id"]');
  variantInput?.addEventListener('change', () => {
    const variant = getVariantFromPicker();
    if (String(variant?.id) === String(variantInput.value)) {
      syncVariantId(variant);
    }
  });

  submitButton?.addEventListener('click', (event) => {
    if (notifyForm.classList.contains('is-success')) {
      event.preventDefault();
      if (typeof modal.hide === 'function') modal.hide();
    }
  });

  notifyForm.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (notifyForm.classList.contains('is-success')) return;

    const variant = getVariantFromPicker();
    if (!isVariantEligibleForNotify(variant)) return;

    const email = emailInput?.value?.trim();
    const variantId = notifyForm.querySelector('[data-notify-variant-id]')?.value;

    if (!email || !variantId || !klaviyoCompanyId) return;

    if (introDescription) introDescription.textContent = defaultDescription;
    submitButton?.setAttribute('aria-busy', 'true');

    try {
      await subscribeToKlaviyoBackInStock(email, variantId);
      showSuccessState();
    } catch (error) {
      submitButton?.removeAttribute('aria-busy');
      showErrorState();
    }
  });
}

function initNotifyMeModals() {
  document.querySelectorAll('[data-notify-me-form]:not([data-notify-me-bound])').forEach((notifyForm) => {
    notifyForm.dataset.notifyMeBound = 'true';
    initNotifyMeModal(notifyForm);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNotifyMeModals);
} else {
  initNotifyMeModals();
}
